module.exports = __webpack_public_path__ + "images/ebooks/effective-strategies-69ea159cd732a0e1b598232ca19237ac.webp";